import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { Club } from '@fable/types'
import { ClubModeratorAvatar } from './ClubModeratorAvatar'

interface Props {
  club: Club | null
}

export const ClubModeratorAvatars = ({ club }: Props) => {
  if (!club || !club?.moderators?.length) return null

  const moderators = club.moderators.slice(0, 4)
  const moderatorCount = moderators.length

  return (
    <FlexBox
      data-testid="club-moderator-avatars"
      className={css`
        flex-shrink: 0;
      `}
      alignItems="center"
      justifyContent="flex-end"
    >
      {moderators.slice(0, 4).map((moderator, i) => {
        const isLast = i === moderatorCount - 1

        return (
          <ClubModeratorAvatar
            key={moderator.id}
            className={css`
              margin-right: ${!isLast ? '-24px' : '0'};
              z-index: ${moderatorCount - i};
            `}
            image={moderator.pic_resize}
            altTag={`${moderator.display_name} avatar`}
            hasIcon={i === 0 || (moderatorCount === 2 && i === 1)}
            iconAlign={isLast && moderatorCount === 2 ? 'right' : 'left'}
          />
        )
      })}
    </FlexBox>
  )
}
